import axios from "axios";
import * as actionTypes from "./actionTypes";
import { openSuccess, openError, openInfo } from "./notification"

export const getList = list => ({
  type: actionTypes.GET_ASSETS,
  list
})

export const getAssets = () =>
  dispatch => {
    axios.get(`${process.env.REACT_APP_SERVER_URL}/api/asset/`, {
    })
      .then(res => {
        dispatch(getList(res.data.results));
      })
      .catch((err) => {
        console.error("Failed to fetch assets:", err);
      });
  }


export const createAsset = (asset_id, name, location, subLocation, deviceLocation, deviceID, jsonData) =>
  dispatch => {
    const token = localStorage.getItem("token");
    const headers = { Authorization: `Token ${token}` };
    axios
      .post(`${process.env.REACT_APP_SERVER_URL}/api/asset/create`, {
        asset_id, name, location, sub_location: subLocation, device_location: deviceLocation, device_id: deviceID, json_data: JSON.stringify(jsonData)
      }, { headers })
      .then((res) => {
        if (res)
          dispatch(getAssets());
        dispatch(openSuccess(true, "Create Success!", "New Asset has been created.", "Just now"));
      })
      .catch(() => {
        dispatch(openError(true, "Create Failed!", "There was an error to create.", "Just now"));
      });

  };


export const updateAsset = (id, asset_id, name, location, subLocation, deviceLocation, deviceID, jsonData) =>
  dispatch => {
    const token = localStorage.getItem("token");
    const headers = { Authorization: `Token ${token}` };
    axios
      .put(`${process.env.REACT_APP_SERVER_URL}/api/asset/update/${id}/`, {
        asset_id, name, location, sub_location: subLocation, device_location: deviceLocation, device_id: deviceID, json_data: JSON.stringify(jsonData)
      }, { headers })
      .then(res => {
        if (res)
          dispatch(getAssets());
        dispatch(openInfo(true, "Update Success!", "The Asset has been updated.", "Just now"));
      })
      .catch(() => {
        dispatch(openError(true, "Update Failed!", "There was an error to update.", "Just now"));
      });

  };


export const deleteAsset = (id) =>
  dispatch => {
    const token = localStorage.getItem("token");
    const headers = { Authorization: `Token ${token}` };
    axios
      .delete(`${process.env.REACT_APP_SERVER_URL}/api/asset/delete/${id}/`, { headers })
      .then(res => {
        if (res)
          dispatch(getAssets());
        dispatch(openSuccess(true, "Delete Success!", "The Asset has been deleted.", "Just now"));
      })
      .catch(() => {
        dispatch(openError(true, "Delete Failed!", "There was an error to delete.", "Just now"));
      });

  };




